<template>
	<dms-collapse-item :key="collapseKey" :name="name" class="collapse-table-component">
		<template slot="title">
			{{ titleText }}
			<div class="action-buttons">
				<!-- user defined buttons in slot -->
				<slot name="userDefinedButtons" />

				<!-- default create and export buttons -->
				<template v-if="showDefaultButtons">
					<dms-button v-if="canSave" :disabled="isDisabled" label-key="cmdUlozit" @click.prevent.stop="saveClickFunc" />
					<dms-button v-if="canCreate" :disabled="isDisabled" label-key="cmdVytvor" @click.prevent.stop="createClickFunc" />
					<dms-button v-if="canExport" :disabled="isDisabled" label-key="Export" @click.prevent.stop="exportClickFunc" />
				</template>
			</div>
		</template>
		<slot />
		<dms-table ref="table" v-bind="{table, rowKey, extraOperationsAloved, objectName, rowsOnPage, tableDisabled, selectRow, extraButtons,
			handleSelectionChange, multipleSelection, tableCellStyle}" v-on="$listeners" />
	</dms-collapse-item>
</template>

<script>
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { COLUMN_ID_INDEX } from '@/main/utils/table';

import { DmsBaseComponent } from '#components/dms/common/base';
import { OperationFlags, getModeOperations } from '#components/dms/common/operationFlagsConstants';

export default DmsBaseComponent.extend({
	name: 'DmsCollapseTable',
	inject: {
		tabsChild: { default: false },
	},
	props: {
		multipleSelection: Array,
		handleSelectionChange: { type: Object, default: () => {} },
		table: { type: Object, default: () => {} },
		rowKey: { type: String, default: COLUMN_ID_INDEX },
		objectName: { type: String, default: undefined },
		name: { type: String, required: true },
		createClickFuncProp: { type: Function, default: undefined },
		exportClickFuncProp: { type: Function, default: undefined },
		filter: { type: Object, default: undefined },
		useCreate: { type: Boolean, default: false },
		useExport: { type: Boolean, default: false },
		useSave: { type: Boolean, default: false },
		showDefaultButtons: { type: Boolean, default: true },
		rowsOnPage: { type: Number, default: undefined },
		tableDisabled: { type: Boolean, default: false },
		extraOperationsAloved: { type: Number, default: 0 },
		selectRow: [String, Number],
		extraButtons: { type: Object, default: () => {} },
		tableCellStyle: { type: Function, required: false },		
	},
	data() {
		return {
			collapseKey: 0,
		};
	},
	computed: {
		titleText() {
			return this.getText(this.label, this.labelKey, undefined, this.LocalizePopisostatni);
		},
		hasCreateEvent() {
			return this.$listeners && this.$listeners['create-click'];
		},
		hasExportEvent() {
			return this.$listeners && this.$listeners['export-click'];
		},
		canCreate() {
			if (this.createClickFuncProp || this.hasCreateEvent) {
				return this.useCreate && this.pageMode !== PageMode.VIEW;
			}
			// eslint-disable-next-line no-bitwise
			return this.useCreate && getModeOperations(this.pageMode, this.table.operations & OperationFlags.CREATE);
		},
		canExport() {
			// eslint-disable-next-line no-bitwise
			return this.useExport && getModeOperations(this.pageMode, this.table.operations & OperationFlags.EXPORT);
		},
		canSave() {
			return this.useSave && this.pageMode === PageMode.EDIT;
		},
		editClickMaybe() {
			return this.$listeners && this.$listeners.editClick ? { editClick: (payload) => this.$emit('editClick', payload) } : {};
		},
		tableRows() {
			return this.table.rows;
		},
	},
	watch: {
		tableRows() {
			if (this.tabsChild && this.table.rows.length > 0 && this.table.columns.length > 0) {
				this.$nextTick(() => {
					this.$refs.table && this.$refs.table.refreshLayout();
				});
			}
		},
	},
	methods: {
		createClickFunc() {
			if (this.hasCreateEvent) {
				this.$emit('create-click');
				return;
			}
			if (this.createClickFuncProp) {
				this.createClickFuncProp();
				return;
			}
			openEdit(this.objectName, PageMode.CREATE, { props: true, filter: this.filter });
		},
		exportClickFunc() {
			if (this.hasExportEvent) {
				this.$emit('export-click');
				return;
			}
			if (this.createClickFuncProp) {
				this.exportClickFuncProp();
				return;
			}
			// TODO: implement export function
			console.log('export neni implementovan');
		},
		saveClickFunc() {
			this.$emit('save-click');
		},
		refreshLayout() {
			this.collapseKey += 1;
		},
	},
});
</script>

<style lang="scss" scoped>
.action-buttons {
	float: right;
	padding-right: 10px;
	margin-left: auto;
}

::v-deep .el-collapse-item__arrow {
	margin-left: 0;
}
</style>
